import { Typography } from '@pickupp/ui/core'
import { makeStyles } from '@pickupp/ui/styles'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './styles'

const useStyles = makeStyles(styles)

const Header = (props) => {
  const { title, notes } = props

  const classes = useStyles()

  return (
    <div className={classes.headerContainer}>
      <div className={classes.header}>
        <Typography
          variant="h5"
          className={classes.textSpacing}
        >
          {title}
        </Typography>
        {notes && (
          <Typography
            variant="body2"
            weight={600}
            className={classes.textSpacing}
          >
            {notes}
          </Typography>
        )}
      </div>
    </div>
  )
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  notes: PropTypes.string,
}

Header.defaultProps = {
  notes: null,
}

export default Header
